import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { PATHS } from './paths';
import { ProtectedRoute } from './ProtectedRoute';
import { Spinner } from '@/shared/components/ui/Spinner';

const LoginPage = lazy(() => import('@/pages/LoginPage'));
const DashboardPage = lazy(() => import('@/pages/DashboardPage'));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));
const HomePage = lazy(() => import('@/pages/HomePage'));
const HowItWorksPage = lazy(() => import('@/pages/HowItWorksPage'));
const ForOrganizationsPage = lazy(() => import('@/pages/ForOrganizationsPage'));
const PricingPage = lazy(() => import('@/pages/PricingPage'));
const AboutPage = lazy(() => import('@/pages/AboutPage'));
const BlogPage = lazy(() => import('@/pages/BlogPage'));
const ContactPage = lazy(() => import('@/pages/ContactPage'));
const JoinBetaPage = lazy(() => import('@/pages/JoinBetaPage'));
const FAQPage = lazy(() => import('@/pages/FAQPage'));
const TermsOfServicePage = lazy(() => import('@/pages/TermsOfServicePage'));
const PrivacyPolicyPage = lazy(() => import('@/pages/PrivacyPolicyPage'));
const CodeOfConductPage = lazy(() => import('@/pages/CodeOfConductPage'));
const CookiePolicyPage = lazy(() => import('@/pages/CookiePolicyPage'));
const RequestDemoPage = lazy(() => import('@/pages/RequestDemoPage'));
const AppRedirectPage = lazy(() => import('@/pages/AppRedirectPage'));
const DeleteAccountPage = lazy(() => import('@/pages/DeleteAccountPage'));
const BlogsById = lazy(() => import('@/pages/BlogsById'));
const ChildSafetyStandardsPage = lazy(() => import('@/pages/ChildSafetyPage'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageLoader() {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-[#0E0E0E]">
      <Spinner size="lg" />
    </div>
  );
}

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <ScrollToTop />
      <Routes>
        <Route path={PATHS.HOME} element={<HomePage />} />
        <Route path={PATHS.HOW_IT_WORKS} element={<HowItWorksPage />} />
        <Route path={PATHS.FOR_ORGANIZATIONS} element={<ForOrganizationsPage />} />
        <Route path={PATHS.PRICING} element={<PricingPage />} />
        <Route path={PATHS.ABOUT} element={<AboutPage />} />
        <Route path={PATHS.BLOG} element={<BlogPage />} />
        <Route path={PATHS.BLOGSBYID} element={<BlogsById />} />
        <Route path={PATHS.CONTACT} element={<ContactPage />} />
        <Route path={PATHS.JOIN_BETA} element={<JoinBetaPage />} />
        <Route path={PATHS.FAQ} element={<FAQPage />} />
        <Route path={PATHS.TERMS_OF_SERVICE} element={<TermsOfServicePage />} />
        <Route path={PATHS.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
        <Route path={PATHS.CODE_OF_CONDUCT} element={<CodeOfConductPage />} />
        <Route path={PATHS.COOKIE_POLICY} element={<CookiePolicyPage />} />
        <Route path={PATHS.REQUEST_DEMO} element={<RequestDemoPage />} />
        <Route path={PATHS.DELETE_ACCOUNT} element={<DeleteAccountPage />} />
        <Route path={PATHS.CHILD_SAFETY_STANDARDS} element={<ChildSafetyStandardsPage />} />
        <Route path={PATHS.LOGIN} element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path={PATHS.DASHBOARD} element={<DashboardPage />} />
        </Route>
        <Route path={PATHS.APP_REDIRECT} element={<AppRedirectPage />} />
        <Route path={PATHS.NOT_FOUND} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
